import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/MarketplaceHashtagCloud.graphql';
import { Query, QuerymarketplaceHashtagCloudArgs } from '../../__generated__/globalTypes';

export const useMarketplaceHashtagCloudQuery = (
  options?: QueryHookOptions<Query, QuerymarketplaceHashtagCloudArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerymarketplaceHashtagCloudArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useMarketplaceHashtagCloudLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerymarketplaceHashtagCloudArgs>
): QueryResult<Query, QuerymarketplaceHashtagCloudArgs> & {
  getMarketplaceHashtagCloud: LazyQueryExecFunction<Query, QuerymarketplaceHashtagCloudArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getMarketplaceHashtagCloud, result] = useLazyQuery<Query, QuerymarketplaceHashtagCloudArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getMarketplaceHashtagCloud, ...result };
};

export const useMarketplaceHashtagCloudPromiseQuery = () => {
  const client = useApolloClient();

  const getMarketplaceHashtagCloud = useCallback(
    (options?: Omit<QueryOptions<QuerymarketplaceHashtagCloudArgs, Query>, 'query'>) =>
      client.query<Query, QuerymarketplaceHashtagCloudArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getMarketplaceHashtagCloud };
};
// Suspense Query Hooks
export const useMarketplaceHashtagCloudSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerymarketplaceHashtagCloudArgs>
) => {
  const result = useSuspenseQuery<Query, QuerymarketplaceHashtagCloudArgs>(QUERY, {
    ...options
  });

  return result;
};
